import {VideoCameraOutlined} from '@ant-design/icons'
import Commonview from '../../../pages/common_view';
import Recording from "../../../pages/recordingManage";

export const RecordingRouter = [
    {
        path: "/recording",
        element: <Commonview/>,
        meta: {title: '录音管理', icon: <VideoCameraOutlined />},
        children: [
            {
                path: "/recording/video_manage",
                meta: {title: '录音列表', key: 'call_recording_management'},
                element: <Recording/>,
            }
        ]
    }
];

export default RecordingRouter
